import colors from "@digits-shared/themes/colors"
import { css } from "styled-components"

export const GlassLayer = css`
  background: ${colors.translucentWhite40};
  border: 1px solid ${colors.translucentWhite40};
  background-blend-mode: luminosity;
  backdrop-filter: blur(8px);
`
